import { Button, Grid, Header } from '@mairistem/composants';
import { type Exercice, Sens } from '@mairistem/comptabilite';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import type Composant from '../../../interfaces/common/composant';
import type Financement from '../../../interfaces/common/financement';
import type ProImputation from '../../../interfaces/common/proImputation';
import FinancementItem from './FinancementItem';

interface ComposantItemProps {
	composant: Composant;
	decision: number;
	exercices: Exercice[];
	exercicesGestionTva: Set<number>;
	exercicesReportFonc: Set<number>;
	exercicesSansEspace: Set<number>;
	identifiantService: number | null;
	isGestionParService: boolean;
	onAddFinancement: () => void;
	onAddProImputation: (identifiantFinancement: number | string) => void;
	onChangeFinancement: (
		data: Partial<Financement>,
		identifiantFinancement: number | string,
	) => void;
	onChangeProImputation: (
		data: Partial<ProImputation>,
		identifiantProImputation: number | string,
		identifiantFinancement: number | string,
	) => void;
	onRemoveFinancement: (identifiantFinancement: number | string) => void;
	onRemoveProImputation: (
		identifiantProImputation: number | string,
		identifiantFinancement: number | string,
	) => void;
	sens: string;
}

const ComposantItem = ({
	composant,
	decision,
	exercices,
	exercicesGestionTva,
	exercicesReportFonc,
	exercicesSansEspace,
	identifiantService,
	isGestionParService,
	onAddFinancement,
	onAddProImputation,
	onChangeFinancement,
	onChangeProImputation,
	onRemoveFinancement,
	onRemoveProImputation,
	sens,
}: ComposantItemProps) => (
	<>
		<Grid>
			<Grid.Row>
				<Grid.Column verticalAlign="middle" width={13}>
					<Header
						content={`${composant.libelle} | ${formatMontant(composant.montantEvenement)}`}
						size="small"
					/>
				</Grid.Column>
				<Grid.Column textAlign="right" verticalAlign="middle" width={3}>
					<Button
						content={`Ajouter ${sens === Sens.DEPENSE ? 'crédit' : 'ressource'}`}
						data-testid="addFinancementButton"
						icon="plus"
						onClick={onAddFinancement}
						primary
						size="tiny"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
		{composant.financements?.map(
			(financement) =>
				financement.sens === sens && (
					<FinancementItem
						decision={decision}
						exercices={exercices}
						exercicesGestionTva={exercicesGestionTva}
						exercicesReportFonc={exercicesReportFonc}
						exercicesSansEspace={exercicesSansEspace}
						financement={financement}
						identifiantService={identifiantService}
						isGestionParService={isGestionParService}
						key={financement.identifiant}
						onAddProImputation={() =>
							onAddProImputation(financement.identifiant)
						}
						onChangeFinancement={(data) =>
							onChangeFinancement(data, financement.identifiant)
						}
						onChangeProImputation={(data, identifiantProImputation) =>
							onChangeProImputation(
								data,
								identifiantProImputation,
								financement.identifiant,
							)
						}
						onRemoveFinancement={() =>
							onRemoveFinancement(financement.identifiant)
						}
						onRemoveProImputation={(identifiantProImputation) =>
							onRemoveProImputation(
								identifiantProImputation,
								financement.identifiant,
							)
						}
					/>
				),
		)}
	</>
);

export default ComposantItem;
